import type { IntlShape } from 'react-intl'

export const formatChatLabel = (isoDate: string): string => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return isoDate
  }

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export const formatChatSubtitle = (isoDate: string, intl: IntlShape): string => {
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return isoDate
  }

  const dateTimeStr = date.toLocaleString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    day: 'numeric',
    month: 'long',
  })

  return intl.formatMessage(
    {
      id: 'lZgrKlVcD4AaPFhmGiIT',
      defaultMessage: 'Last updated at {dateTime}',
      description: 'Subtitle showing when a chat was last updated in the drawer list',
    },
    { dateTime: dateTimeStr },
  )
}
